export const I18nConfig = Object.freeze({
  defaultLang: 'en-US',
  resourcePath: './assets/i18n/',
  resourceUri: '/assets/i18n/',
  suffix: '.json',
  modules: {
    SIGN_IN: 'sign-in',
    account: {
      REGISTER: 'register',
      COMPLETE_REGISTRY: 'complete-registry',
    },
    planner: {
      DASHBOARD: 'dashboard',
    },
  },
});
